<template>
    <div class="main">
        <c-panel>
            <grupos></grupos>
        </c-panel>
    </div>
</template>
<script>

import grupos from "./grupos"

export default {
    components:{ grupos }
}
</script>
